module.exports = __webpack_public_path__ + "static/media/sohu.8042d8ee.png";